module.exports = "### Components\n\n- Blocks used to build app\n\n- Like Lego bricks\n\n- Combined in different ways (or composed) to create larger components\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/10_components/notes_1.md
// module id = 1519
// module chunks = 0